/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["nombre"];

export default function ActividadesTipos() {
  const [loader, setLoader] = useState(true);
  const [tiposActividades, setTiposActividades] = useState();
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  const formularioConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre de la actividad",
            requerido: true
          },
          {
            nombre: "disponiblesolicitud",
            tipoitemformularioid: 6,
            etiqueta: "Disponible para solicitudes de clientes"
          },
          {
            nombre: "correspondeemision",
            tipoitemformularioid: 6,
            etiqueta: "Corresponde emisión de certificado"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear tipo de actividad",
        callback: crearTipoActividad,
        validar: true
      }
    ]
  };

  function crearTipoActividad(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/actividad/actividadTipo",
      camposFormulario,
      (respuesta) => {
        navigate(`/actividades/tipos/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear tipo de actividad",
          sticky: true
        });
      }
    );
  }

  useEffect(() => {
    document.title = "Tipos de actividades";
    accessAPI(
      "GET",
      "admin/actividad/actividadTipo",
      null,
      (respuesta) => {
        setTiposActividades(
          respuesta.sort((a, b) => a.nombre.localeCompare(b.nombre))
        );
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar tipos de actividades",
          sticky: true
        });
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        closeIcon={
          <div>
            <i className="pi pi-times"></i>
          </div>
        }
        className="w-full lg:w-30rem md:w-30rem"
      >
        <div css={{ marginBottom: "50px" }}>
          <Titulo>Nuevo tipo de actividad</Titulo>
          <Formulario config={formularioConfig} loader={formLoader} />
        </div>
      </Sidebar>

      {loader && (
        <div>
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1em",
              marginTop: "2em"
            }}
          >
            <Skeleton width="16rem" height="2rem" />
            <Skeleton width="2.5rem" height="2.5rem" />
          </div>
          <Skeleton width="100%" height="15rem" />
        </div>
      )}

      {!loader && tiposActividades && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>Nueva actividad</Boton>
            }
          >
            Tipos de actividades
          </Titulo>

          <Card>
            <TablaFiltrable
              value={tiposActividades}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="tipos_actividad"
              size="small"
              emptyMessage="No hay tipos de actividades"
              selectionMode="single"
              onRowSelect={(e) => navigate(`${e.data.id}`)}
              rowHover
            >
              <Column field="nombre" header="Tipo de actividad" />
              <Column
                body={(rowData) => (
                  <i
                    className={
                      rowData.disponible
                        ? "pi pi-check-circle"
                        : "pi pi-times-circle"
                    }
                    title={rowData.disponible ? "Habilitada" : "Deshabilitada"}
                    css={{
                      color: rowData.disponible
                        ? "var(--verde)"
                        : "var(--rojo)",
                      fontSize: "1.1rem"
                    }}
                  />
                )}
                style={{ width: "4rem", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
